var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentcreationtab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 765 277",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-22,.cls-24,.cls-32,.cls-34,.cls-38,.cls-39,.cls-40{fill:none;}.cls-2{isolation:isolate;}.cls-3{fill:#d8c4df;}.cls-4{font-size:35px;font-family:CenturyGothic-Bold, Century Gothic;font-weight:700;}.cls-4,.cls-5{fill:#2f2143;}.cls-6{fill:#fff;}.cls-7{fill:#9ca1a4;}.cls-8{fill:#2e3133;}.cls-9{fill:#fdc437;}.cls-10{fill:#9a499c;}.cls-11{fill:#b0adad;}.cls-12{fill:#3a7abc;}.cls-13{fill:#59add1;}.cls-14{fill:#231f20;}.cls-15{mix-blend-mode:darken;}.cls-16{clip-path:url(#clip-path);}.cls-17{clip-path:url(#clip-path-2);}.cls-18{clip-path:url(#clip-path-3);}.cls-19{opacity:0.5;}.cls-20{clip-path:url(#clip-path-4);}.cls-21{fill:#ffc436;}.cls-22{stroke:#3a4c69;stroke-width:0.36px;}.cls-22,.cls-24,.cls-32,.cls-34,.cls-38,.cls-39,.cls-40{stroke-miterlimit:10;}.cls-23{fill:#fdfefe;}.cls-24,.cls-40{stroke:#fff;}.cls-24{stroke-width:0.62px;}.cls-25{fill:#a6a5a5;}.cls-26{fill:#dcdbdb;}.cls-27{fill:#ad6359;}.cls-28{fill:#ffc829;}.cls-29{fill:#5e433f;}.cls-30{fill:#493d3c;}.cls-31{fill:#7f4843;}.cls-32{stroke:#263238;stroke-linecap:round;stroke-width:0.72px;}.cls-33{clip-path:url(#clip-path-5);}.cls-34{stroke:#2f2143;stroke-width:0.51px;}.cls-35{fill:#e5ac24;}.cls-36{fill:#cd922a;}.cls-37{clip-path:url(#clip-path-6);}.cls-38,.cls-39{stroke:#9a499c;}.cls-38{stroke-width:0.44px;}.cls-39{stroke-width:0.64px;}.cls-40{stroke-width:0.53px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 609.22,
    y: 177.53,
    width: 34.24,
    height: 0.55
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 649.39,
    y: 177.6,
    width: 31.94,
    height: 0.55
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 688.44,
    y: 177.6,
    width: 29.5,
    height: 0.55
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 144.6,
    y: 24.56,
    width: 21.56,
    height: 21.56
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 33.48,
    y: 30.08,
    width: 32.42,
    height: 32.42
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 522.82,
    y: 70.77,
    width: 29.17,
    height: 29.17
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "content creation tab") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 765,
    height: 277
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(193.82 161.65)"
  }, "CONTENT MARKETING"), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M743.51,186.05H584.05v-90a8.33,8.33,0,0,1,8.32-8.32H735.18a8.33,8.33,0,0,1,8.33,8.32Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 589.85,
    y: 93.59,
    width: 147.85,
    height: 89.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M736.43,199H591.12a7.08,7.08,0,0,1-7.07-7.08v-5.89H743.51v5.89a7.08,7.08,0,0,1-7.08,7.08"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 651.18,
    y: 199.02,
    width: 29.45,
    height: 11.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 644.58,
    y: 210.03,
    width: 41.57,
    height: 2.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M665.91,192.54a2.14,2.14,0,1,1-2.13-2.14,2.13,2.13,0,0,1,2.13,2.14"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 609.22,
    y: 130.5,
    width: 34.67,
    height: 31.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 649.19,
    y: 130.58,
    width: 32.34,
    height: 31.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 688.07,
    y: 130.58,
    width: 29.86,
    height: 31.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 589.85,
    y: 93.59,
    width: 147.85,
    height: 8.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M718.84,99.5h-100a1.42,1.42,0,1,1,0-2.84h100a1.42,1.42,0,1,1,0,2.84"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 721.64,
    y: 96.66,
    width: 6.61,
    height: 2.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 729.46,
    y: 96.66,
    width: 6.61,
    height: 2.84
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M595.94,98.08a1.42,1.42,0,1,1-1.42-1.42,1.43,1.43,0,0,1,1.42,1.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M601.26,98.08a1.42,1.42,0,1,1-1.42-1.42,1.43,1.43,0,0,1,1.42,1.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M606.57,98.08a1.42,1.42,0,1,1-1.42-1.42,1.42,1.42,0,0,1,1.42,1.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M611.89,98.08a1.42,1.42,0,1,1-1.42-1.42,1.43,1.43,0,0,1,1.42,1.42"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 599.16,
    y: 102.57,
    width: 122.48,
    height: 9.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 721.64,
    y: 102.57,
    width: 16.06,
    height: 80.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 589.85,
    y: 102.57,
    width: 16.06,
    height: 80.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 605.92,
    y: 111.65,
    width: 115.73,
    height: 13.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 609.22,
    y: 114.82,
    width: 27.96,
    height: 7.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 643.89,
    y: 119.89,
    width: 11.05,
    height: 2.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 659.68,
    y: 119.89,
    width: 11.05,
    height: 2.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 675.48,
    y: 119.89,
    width: 11.05,
    height: 2.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 691.27,
    y: 119.89,
    width: 11.05,
    height: 2.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 707.06,
    y: 119.89,
    width: 11.05,
    height: 2.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 609.22,
    y: 165.24,
    width: 34.24,
    height: 0.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 609.22,
    y: 167,
    width: 34.24,
    height: 0.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 609.22,
    y: 168.75,
    width: 34.24,
    height: 0.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 609.22,
    y: 170.51,
    width: 34.24,
    height: 0.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 609.22,
    y: 172.26,
    width: 34.24,
    height: 0.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 609.22,
    y: 174.02,
    width: 34.24,
    height: 0.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 609.22,
    y: 175.77,
    width: 34.24,
    height: 0.55
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 609.22,
    y: 177.53,
    width: 34.24,
    height: 0.55
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 649.39,
    y: 165.32,
    width: 31.94,
    height: 0.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 649.39,
    y: 167.07,
    width: 31.94,
    height: 0.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 649.39,
    y: 168.83,
    width: 31.94,
    height: 0.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 649.39,
    y: 170.58,
    width: 31.94,
    height: 0.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 649.39,
    y: 172.34,
    width: 31.94,
    height: 0.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 649.39,
    y: 174.09,
    width: 31.94,
    height: 0.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 649.39,
    y: 175.85,
    width: 31.94,
    height: 0.55
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 649.39,
    y: 177.6,
    width: 31.94,
    height: 0.55
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 688.44,
    y: 165.32,
    width: 29.5,
    height: 0.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 688.44,
    y: 167.07,
    width: 29.5,
    height: 0.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 688.44,
    y: 168.83,
    width: 29.5,
    height: 0.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 688.44,
    y: 170.58,
    width: 29.5,
    height: 0.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 688.44,
    y: 172.34,
    width: 29.5,
    height: 0.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 688.44,
    y: 174.09,
    width: 29.5,
    height: 0.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 688.44,
    y: 175.85,
    width: 29.5,
    height: 0.55
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 688.44,
    y: 177.6,
    width: 29.5,
    height: 0.55
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "714.64 181.4 692.47 169.02 692.83 194.41 699.87 187.68 712.07 208.14 717.39 204.96 705.16 184.46 714.64 181.4"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M164.74,36.48h0a9.44,9.44,0,0,0-.1-2.91h0l1.31-1.81-.91-2-2.23-.21v0a9.18,9.18,0,0,0-2.13-2h0l-.35-2.21-2.08-.78L156.52,26v0a8.87,8.87,0,0,0-2.91.1h0l-1.81-1.32-2,.91-.21,2.23h0a9.61,9.61,0,0,0-2,2.13h0l-2.21.35-.78,2.07L146,34.2h0a9.45,9.45,0,0,0,.1,2.91h0l-1.32,1.81.92,2,2.23.21v0a9.18,9.18,0,0,0,2.13,2h0l.35,2.21,2.07.78,1.73-1.43v0a9.2,9.2,0,0,0,2.92-.1h0L159,45.9l2-.91.21-2.23h0a9.61,9.61,0,0,0,2-2.13h0l2.21-.35.78-2.07ZM162.46,38a7.57,7.57,0,1,1-4.4-9.75,7.57,7.57,0,0,1,4.4,9.75"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 265.13,
    y: 31.8,
    width: 34.52,
    height: 49.77,
    transform: "matrix(0.96, -0.27, 0.27, 0.96, -4.71, 79.69)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 267.12,
    y1: 48.86,
    x2: 284.25,
    y2: 43.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 268.38,
    y1: 53.25,
    x2: 285.5,
    y2: 48.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 269.63,
    y1: 57.64,
    x2: 286.76,
    y2: 52.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 270.88,
    y1: 62.03,
    x2: 288.01,
    y2: 57.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 272.13,
    y1: 66.42,
    x2: 289.26,
    y2: 61.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 273.39,
    y1: 70.81,
    x2: 290.52,
    y2: 65.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 274.64,
    y1: 75.2,
    x2: 291.77,
    y2: 70.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 275.89,
    y1: 79.59,
    x2: 293.02,
    y2: 74.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 284,
    y: 32.11,
    width: 7.89,
    height: 8.37,
    transform: "translate(1.1 80.43) rotate(-15.93)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M187.47,103.23a5.89,5.89,0,1,1-5.89-5.89A5.89,5.89,0,0,1,187.47,103.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M288.28,245.39a5.89,5.89,0,1,1-5.89-5.89A5.89,5.89,0,0,1,288.28,245.39Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "60.52 263.92 59.13 263.76 64.8 203.35 68.56 203.78 60.52 263.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "126.66 263.25 125.28 263.53 111.69 204.4 115.41 203.62 126.66 263.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "92.48 261.23 91.08 261.23 89.88 200.57 93.68 200.57 92.48 261.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "60.06 139.48 91.57 139.48 101.24 195.75 130.02 195.75 130.02 203.85 57.33 203.85 60.06 139.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M112.62,161.56l-31.83.95S68.66,192,95,197.31c0,0,17.24,4.79,22.9,4.85,0,0,16.42,1.87,19.34,3.73,0,0,2.51-4.81,5.9,56.19H161s1.25-49.8-2.12-59.34c0,0,.7-10.53-12.44-16.16,0,0-21.61-11.55-36.74-15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M117.5,115.36a16.37,16.37,0,0,0-.59,2c-.07.56-.48,6.22-4,4.93s-5.43-6.78-5.25-7.35l2.94-7.27,0-1.17s-2.66-2.32-.55-6.39c0,0,1.36-1.76,2.65,1.73L116.06,97l9.22-.73,3,4.53-.52,2s-.81,4.35-1.6,5.68c0,0-2.4,8-8.64,6.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M116,98s-.58,3.47-3.5,3.91c0,0-3.61.07-2.61-3.84,0,0,.49-2,1.49-2.2,0,0-.79-6.37,5.91-5.23,0,0,4-3.45,7.77,1.6,0,0,5.51.11,3.72,7.07,0,0,1.37,2.69-1.27,3.59l.11-2.18s-3.57-1.46-2.93-4.85c0,0-1.75,5.87-8.69,2.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M114.21,161.56l-28.56.85s-8.09,16.44,5.9,24.28c0,0,9.14,4.6,23.59,5.58,0,0,7.55.89,8.7,1.43,0,0,.88,0,.06,2.42S109,251.45,109,251.45l15.81,3.43s25.61-45.44,27.6-59.18c0,0,6.68-16.34-7.56-20a122.12,122.12,0,0,0-29.87-7.3s-1.43-2.29-.77-6.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M121,164l-43-.61s8.61-25.67,11.72-29c0,0,10.06-18.19,17.06-19.3,0,0,1.38-1.28,1.36-1s5.52,8.47,5.52,8.47l3.37-5.14a138.58,138.58,0,0,1,7.18,22.26l25.19,4.18s-3.36,16.34-4,16.68-24.17-5-24.17-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M113.94,102.86c.32,1.8-.51,3.45-1.85,3.68s-2.68-1-3-2.83.52-3.44,1.86-3.68,2.68,1,3,2.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M110.53,104.25c.6-.47,1.31.22,1.51.78l-.3.12a3.58,3.58,0,0,1,.15-3.57A5.06,5.06,0,0,0,112,105l-.3.12c-.17-.52-.56-1.13-1.21-.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M111.14,159.27a4.53,4.53,0,0,0,3.72-.26,18.14,18.14,0,0,1,2.39,2.06,1.39,1.39,0,0,0,1.59.07,1.26,1.26,0,0,0,.47-.75,1.51,1.51,0,0,0,0-.82,2.18,2.18,0,0,0,2.35.4,1.42,1.42,0,0,0,.5-.6,1.78,1.78,0,0,0-.09-1.15,4,4,0,0,0-.42-.92,2.45,2.45,0,0,0,2.56.49,1.27,1.27,0,0,0,.52-.61,1.66,1.66,0,0,0-.08-1,4,4,0,0,0-.41-.94c-.26-.39-.55-.8-.89-1.22a13.88,13.88,0,0,0-2.3-2.32s3.72,2.53,4.3,2.83a1.24,1.24,0,0,0,1.46,0c.36-.38.13-1.07,0-1.39a2.46,2.46,0,0,0-.66-1,8.64,8.64,0,0,0-10.29-4.62c-4.37,1.49-6.87,7-4.69,11.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M119.26,159.57s-.39-1.62-2.85-2.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M121.6,157.3a7.3,7.3,0,0,0-3.33-2.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M107.67,134.45c-1,4-2.13,7.88-3.32,11.78l-.34-.45c5.26,0,10.51,0,15.77.35-5.41.31-10.83.38-16.25.35,1.29-4,2.64-8.06,4.14-12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M111.21,161.36c-6.35,0-20.48-1.09-24.26-6.67,3.93,4.63,18.13,5.77,24.26,6.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M111.21,147.63c-3.28,2.3-3.65,6.64-3.12,10.29.09.55.18,1.09.24,1.65-1.82-3.91-1.68-10,2.88-11.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M107.09,250.47s-1.6,10.31-.77,13.53c0,0,26.18,7.15,31.83,7.33,0,0,1.33-.72-.2-5.48L126.23,254.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M142.32,261.48l20,.17L175,270s2.51,3.25,1.05,5.84c0,0-30.44.81-33.29-.74,0,0-1.26-4.48-.42-13.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M143.68,266.46c10.21-.47,20.55-.48,30.76,0-10.21.47-20.55.46-30.76,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M107.81,262.08c9.69,1.93,19.39,4.35,28.84,7.22-9.69-1.92-19.39-4.35-28.84-7.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M124,257.53c.68-1.49,3.27-2.71,4.3-.95-1.58-.71-2.84.32-4.3.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M125.79,259.28c.68-1.49,3.26-2.71,4.3-.95-1.58-.71-2.84.32-4.3.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M127.67,260.9c.69-1.49,3.27-2.71,4.31-1-1.58-.71-2.84.33-4.31,1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M162.35,265.2c.68-1.48,3.27-2.7,4.3-.95-1.58-.71-2.84.33-4.3.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M164.5,266.71c.69-1.49,3.27-2.71,4.31-.95-1.59-.72-2.85.32-4.31.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M166.65,268.11c.69-1.49,3.27-2.71,4.31-.95-1.58-.71-2.85.32-4.31.95"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 108.82,
    y: 163.54,
    width: 23.89,
    height: 2.22
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "144.91 138.65 142.6 138.76 130.73 164.91 132.61 165.76 144.91 138.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "144.91 138.65 170.97 138.65 160.09 166.44 132.61 165.76 144.91 138.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M166.39,147.94l1.37-2.24s1.24-2.6,2.88-2.3c0,0,.88.41-.25,2.16a7.51,7.51,0,0,0-1.2,1.95c-.15.67.4,1.67.54,2.28,0,0,.11,1.56-1,1.71a1.92,1.92,0,0,1,.67,1.53s0,.59-1.07.91a1.63,1.63,0,0,1,.42,1.31,1.2,1.2,0,0,1-1.16.92s.3.84.09,1.21c0,0-.08.83-1.8.77a10.37,10.37,0,0,1-4.19-1.32s-1.08-.75-1.23-1.29c0,0-.72-1.52,1-1.15a4.76,4.76,0,0,1-1.31-1.28c-.23-.54-.81-2.27,1.72-1.63,0,0-1.31-.88-1.3-1.58s.22-1.83,2-1.12c0,0-.9-1.58-.42-2,0,0,.37-.9,1.56-.19,0,0,2,1.39,2.67,1.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M162.58,148.78a14.21,14.21,0,0,0,6.16,2.72,7.73,7.73,0,0,1-6.16-2.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M161.9,151.48a25.56,25.56,0,0,0,6.44,2.46,10.13,10.13,0,0,1-6.44-2.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M161.49,154.39a19.33,19.33,0,0,0,6.11,1.78,8.35,8.35,0,0,1-6.11-1.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M118.27,102s2.62-.87,3.33,1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M123.93,103.54s2.62-.87,3.32,1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M117.65,110.5c.47.65,1.23,1.38,2,.69-.64,1-1.73.15-2-.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M119,104.26a.85.85,0,1,0,1.11-.77,1,1,0,0,0-1.11.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M124.44,105.72a.85.85,0,1,0,1.11-.77,1,1,0,0,0-1.11.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M123,105.09a34.77,34.77,0,0,1,.17,4.56c-.46-.31-.92-.63-1.36-1s-.72-.54-1.06-.83c.81.4,1.58.86,2.34,1.33l-.26.15a31.65,31.65,0,0,1,.17-4.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "57.77 203.85 53.44 203.93 56.9 139.42 61.21 139.48 57.77 203.85"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M51,50.88a6.28,6.28,0,1,0-.42.1l.21-.06.21,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M51,50.88l-.21,0-.21.06a12.07,12.07,0,0,0-8.95,9.33,16.13,16.13,0,0,0,21.47-4.89A12.08,12.08,0,0,0,51,50.88"
  }))), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-34",
    points: "16.51 225.26 25.24 231.37 29.11 221.44 37.85 227.54 41.72 217.61 50.45 223.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "358.89 218.72 394.64 232.89 377.08 243.86 358.89 218.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "358.89 218.72 385.74 238.54 385.74 245.62 389.21 237.19 358.89 218.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "381.74 240.1 385.74 245.62 385.74 238.54 381.74 240.1"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M535.64,89.26a5.62,5.62,0,1,0-.35-.17l.18.08.17.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M535.64,89.26l-.17-.09-.18-.08a10.85,10.85,0,0,0-11.55,1.33,14.53,14.53,0,0,0,17.68,8.94,10.87,10.87,0,0,0-5.78-10.1"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M699.69,252.8a8.42,8.42,0,1,1-8.42-8.42A8.42,8.42,0,0,1,699.69,252.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M535.48,219h0a10.82,10.82,0,0,0-.14-3.64h0l1.76-2.26-1.22-2.51-3-.26v0A12.5,12.5,0,0,0,530,207.9h0l-.47-2.76-2.78-1L524.44,206v0a13.86,13.86,0,0,0-3.92.12h0l-2.43-1.64-2.71,1.14-.28,2.78h0a12.29,12.29,0,0,0-2.68,2.66h0l-3,.44-1.05,2.59,1.92,2.14h0a11,11,0,0,0,.13,3.63h0l-1.77,2.26L510,224.6l3,.26,0,0a12.23,12.23,0,0,0,2.86,2.48h0l.47,2.76,2.79,1,2.31-1.78v0a13.53,13.53,0,0,0,3.92-.13v0l2.44,1.64,2.71-1.14.28-2.78,0,0a12,12,0,0,0,2.67-2.65h0l3-.44,1-2.59ZM532.42,221c-2,4.87-7.86,7.33-13.11,5.48s-7.89-7.3-5.9-12.17,7.86-7.33,13.11-5.48,7.89,7.29,5.9,12.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M441.53,50.81a7.31,7.31,0,1,1-7.31-7.31A7.32,7.32,0,0,1,441.53,50.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M685.88,20.64,665.69,35.28a2.4,2.4,0,0,0-.53,3.37L672,48.12a2.43,2.43,0,0,0,3.38.54l1.65-1.2c.58.55,1.9,2.21.5,5,0,0,5.73-4.59,3.46-7.91L695.58,34a2.41,2.41,0,0,0,.54-3.37l-6.86-9.47a2.43,2.43,0,0,0-3.38-.54"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-40",
    x1: 669.93,
    y1: 37.57,
    x2: 686.73,
    y2: 25.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-40",
    x1: 672.16,
    y1: 40.65,
    x2: 688.97,
    y2: 28.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-40",
    x1: 674.61,
    y1: 44.02,
    x2: 691.41,
    y2: 31.84
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentcreationtab);
export default __webpack_public_path__ + "static/media/content creation tab.5651bbb3dbb4ba97f38185f71c351f2a.svg";
export { ForwardRef as ReactComponent };